import { FC, useMemo } from 'react';

import { ActionBar, Button, GridColumn, GridLayout, GridRow, useBreakpoint } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';
import { useDashboardRoute } from 'hooks/useDashboardRoute';

import styles from 'pages/SubscriptionSettingsPage/SubscriptionSettingsPage.module.less';

import { PageContentHeader } from 'components/common/PageContentHeader/PageContentHeader';
import { StickyActionBarWrapper } from 'components/common/StickyActionBarWrapper/StickyActionBarWrapper';
import { Header } from 'components/Header/Header';
import { SubscriptionSettings } from 'components/SubscriptionSettings/SubscriptionSettings';

const TrlKeys = {
    title: 'SubscriptionSettings.title',
    description: 'SubscriptionSettings.description',
    breadcrumbsLink: {
        main: 'Breadcrumbs.main',
        subscriptionSettings: 'SubscriptionSettings.title',
    },
    goToMain: 'SubscriptionSettings.goToMain',
};

export const SubscriptionSettingsPage: FC = () => {
    const trls = useTrls();
    const { isMobile } = useBreakpoint();
    const dashboardRoute = useDashboardRoute();

    const breadcrumbsConfig = useMemo(
        () => [
            { to: dashboardRoute, children: trls(TrlKeys.breadcrumbsLink.main) },
            { to: '#', children: trls(TrlKeys.breadcrumbsLink.subscriptionSettings) },
        ],
        [dashboardRoute, trls]
    );

    return (
        <div className={styles.wrapper}>
            <Header />
            <PageContentHeader
                breadcrumbsConfig={breadcrumbsConfig}
                title={trls(TrlKeys.title)}
                description={trls(TrlKeys.description)}
                vSpacingBottom={24}
            />
            <StickyActionBarWrapper
                content={
                    <GridLayout>
                        <GridRow>
                            <GridColumn xs={4} s={8} m={7}>
                                <SubscriptionSettings />
                            </GridColumn>
                        </GridRow>
                    </GridLayout>
                }
                actionBar={
                    isMobile && (
                        <ActionBar
                            type="vertical"
                            showDivider={false}
                            isSticky
                            primaryActions={
                                <Button
                                    Element="a"
                                    href={dashboardRoute}
                                    data-qa="go-to-main-button"
                                    mode="secondary"
                                    style="accent"
                                >
                                    {trls(TrlKeys.goToMain)}
                                </Button>
                            }
                        />
                    )
                }
            />
        </div>
    );
};
